import { render } from "./B2bTableAccountingCloseDraft.vue?vue&type=template&id=31203681&scoped=true&lang=pug"
import script from "./B2bTableAccountingCloseDraft.vue?vue&type=script&lang=js"
export * from "./B2bTableAccountingCloseDraft.vue?vue&type=script&lang=js"

import "./B2bTableAccountingCloseDraft.vue?vue&type=style&index=0&id=31203681&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31203681"]])

export default __exports__